module.exports = __webpack_public_path__ + "static/img/app4@2x.c774367.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/app4@2x.png
// module id = N5xH
// module chunks = 2